import { IPartnerBenefit } from "@src/api/partner/partner";
import { TWeddingHallCard } from "./weddingHall";

export const UMOMENT_HALL = new Set([
  "38376c92-f64d-11e5-b038-0afd0b3d84dd", // 더채플앳청담
  "55cf2fc7-3841-11ea-9bb0-0ab3aefe6e38", // 더채플앳논현
  "b7d30a51-fa44-11ef-9d4f-023379a10fd2", // 더채플앳대치
  "969bd4a0-8bbf-11e7-93b9-0abe8d4f74d3", // 아펠가모 선릉점
  "b75e9925-1cef-11e6-93b9-0abe8d4f74d3", // 아펠가모 광화문점
  "bc8e931c-2091-11e6-93b9-0abe8d4f74d3", // 아펠가모 잠실점
  "90108185-0c57-11e6-93b9-0abe8d4f74d3", // 아펠가모 반포점
  "728e2aea-7f6b-11e8-aa8e-020502fcb5d0", // 아펠가모 공덕점
  "43ee6d9a-099d-11e9-ab42-020502fcb5d0", // 루벨
]);

type Year = `${number}${number}${number}${number}`;
type Day = `${number}${number}`;
type YYYY_DD = `${Year}-${Day}`; //weddingOpenDate의 형태 지정
type THallVisitor = {
  id: number;
  name: string;
  suggestPersonnel: number;
};
export interface IRealTimeHallInfo {
  partnerId: number;
  name: string;
  storedToConsulting: boolean;
  consultingSlotsDisplayed: boolean;
  consultingUsed: boolean;
  deposit: number;
  weddingOpenDate?: YYYY_DD;
  reservationOpenDate?: number;
  minPersonnel?: number;
  maxPersonnel?: number;
  sugPersonnel?: number;
  reservationNotice?: string;
  individualHalls?: THallVisitor[];
  // 둘 중 하나만 있어도 됨
  consultingUseAutoApproval?: boolean | null;
  useAutoApproval?: boolean | null;
}

interface ReservationItem {
  id: number;
  hallName: string;
  b2cUserId: number;
  visitState: string;
  paymentState: string;
  visitTime: string;
  partnerId: number;
  partnerUuid: string;
  visitDate: string;
  changeableVisit: boolean;
  refundable: boolean;
  dateChangedTsp: string | null;
  paymentStateAlias: string;
  visitStateAlias: string;
  state: number;
}

export interface IMyReservationList {
  item: ReservationItem[];
  result: number;
  total: number;
}

//빠른 예약 목록 조회
export type TRealtimeWeddinghall = TWeddingHallCard & {
  subwayStationName: string;
  subwayLineName: string;
  subwayWalkingTime: number;
  pendingApproval: boolean;
  individualHalls: {
    individualHallId: number;
    adultDrinkFee: number;
    suggestPersonnel: number;
    styleLightingCondition: "DARK" | "BRIGHT";
    stylePrimaryType:
      | "CHAPEL"
      | "CONVENTION"
      | "HOUSE"
      | "HOTEL"
      | "OUTDOOR"
      | "HANOK"
      | "SMALL_SCALE";
    styleSecondaryType:
      | "CHAPEL"
      | "CONVENTION"
      | "HOUSE"
      | "HOTEL"
      | "OUTDOOR"
      | "HANOK"
      | "SMALL_SCALE"
      | null;
    mealTypes: ("BUFFET" | "COURSE" | "ONE_TABLE" | "ONE_TABLE_WITH_SEMI_BUFFET")[];
    ceremonyTypes: ("SAME_TIME" | "SEPARATION")[];
    brideEntranceMethods: (
      | "DIRECT"
      | "VIA_STAIRS"
      | "VIA_HIDDEN_SPACE"
      | "VIA_LIFT"
      | "FROM_FRONT"
      | "FROM_LOBBY"
      | "L_SHAPE"
      | "U_SHAPE"
      | "Z_SHAPE"
      | "ETC"
    )[];
    virginRoadLength: number;
    virginRoadHeight: "HIGH" | "LOW" | "NONE";
    rentalFee: number;
    totalPrice: number;
    additionalInformationTypes: string[];
  }[];
  consulting: {
    openStartDate: string;
    openEndDate: string;
    openDate: number;
    deposit: number;
    slots: {
      dateTime: string;
      slotCounts: number;
      dayOfWeek: string;
      soldOut: boolean;
      date: string;
      time: string;
    }[];
    useAutoApproval: boolean;
  };

  benefits: (IPartnerBenefit & {
    contextScope: string;
    startTsp: string;
    endTsp: string;
  })[];
};

// 리뉴얼된 즉시계약 리스트
export type TContractSlotItem = {
  weddingDayId: number;
  partnerId: number;
  partnerUuid: string;
  partnerProfileName: string;
  imageUrl: string;
  region: string;
  subRegion: string;
  hallName: string;
  finalPrice: number;
  totalPrice: number;
  discountRate: number;
  mealPrice: number;
  rentalPrice: number;
  flowerPrice: number;
  isLike: false;
  weddingDate: string;
  weddingTime: string;
  guarantee: number;
  discountAfterContractType: "IMPOSSIBLE" | "NOT_SET" | "POSSIBLE" | null;
  discountAfterContractTypeAlias: "불가능" | "가능" | null | string;
  tags: { id: number; name: string; color: string }[];
  eventStatus: "NOT_SET" | "DISPLAY" | "HIDE" | string;
};
